
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/csr/industry/market",
      function () {
        return require("private-next-pages/csr/industry/market.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/csr/industry/market"])
      });
    }
  